import axios from "axios";
import { getToken, getUser } from "../Utils/Common";
import token_valid from "./TokenValid";

const getWarehouseTransferBills = async (offset, pageSize, filter) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/warehouse_transfer/all/" + offset + "/" + pageSize,
        {
          billNumber: filter._billNumber ? filter._billNumber.trim() : null,
          productIds: filter._products && filter._products.length !== 0 ? filter._products : null,
          transferredByIds: filter._salesman && filter._salesman.length !== 0 ? filter._salesman : null,
          addedBy: filter._addedBy ? filter._addedBy.trim() : null,
          status: filter._status ? filter._status.trim() : null,
          billCategory: filter._billCategory ? filter._billCategory.trim() : null,
        },
        { headers: { "Content-Type": "application/json", Authorization: "Bearer " + token } }
      )
      .then((response) => response.data)
      .catch((error) => {
        console.log("getWarehouseTransferBills error:", error);
        return "Something went wrong...";
      });
  }
};

const addWarehouseTransferBill = async (values, billItems) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    let user = getUser();
    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/warehouse_transfer/add",
        {
          billDate: values._billDate || null,
          billNumber: values._billNumber || null,
          transferredById: values._transferredById || null,
          totalPrice: values._totalPrice,
          remainingAmount: values._totalPrice,
          totalProfit: values._totalProfit,
          discount_percentage: 0,
          discount_amount: 0,
          addedBy: user.username,
          billCategory: values._billCategory,
          billItems: billItems,
          payments: [],
          note: values._note || "",
          sourceWarehouseId: values._sourceWarehouse,
          destinationWarehouseId: values._destinationWarehouse,
        },
        { headers: { "Content-Type": "application/json", Authorization: "Bearer " + token } }
      )
      .then((response) => response.data)
      .catch((error) => {
        console.log("addWarehouseTransferBill error:", error);
        return null;
      });
  }
};

const getWarehouseTransferBillById = async (billId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(process.env.REACT_APP_API_URL + "/api/warehouse_transfer/" + billId, {
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
      })
      .then((response) => response.data)
      .catch((error) => {
        console.log("getWarehouseTransferBillById error:", error);
        return "Something went wrong...";
      });
  }
};

const sendWarehouseTransferBillForApproval = async (billId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(process.env.REACT_APP_API_URL + "/api/warehouse_transfer/approval/" + billId, {
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
      })
      .then((response) => response.data)
      .catch((error) => {
        console.log("sendWarehouseTransferBillForApproval error:", error);
        return "Something went wrong...";
      });
  }
};

const executeWarehouseTransfer = async (billId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(process.env.REACT_APP_API_URL + "/api/warehouse_transfer/execute/" + billId, {
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
      })
      .then((response) => response.data)
      .catch((error) => {
        console.log("executeWarehouseTransfer error:", error);
        return "Something went wrong...";
      });
  }
};

const confirmWarehouseTransferReceived = async (billId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(process.env.REACT_APP_API_URL + "/api/warehouse_transfer/confirm/" + billId, {
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
      })
      .then((response) => response.data)
      .catch((error) => {
        console.log("confirmWarehouseTransferReceived error:", error);
        return "Something went wrong...";
      });
  }
};

const approveWarehouseTransferBill = async (billId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(process.env.REACT_APP_API_URL + "/api/warehouse_transfer/approve/" + billId, {
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
      })
      .then((response) => response.data)
      .catch((error) => {
        console.log("approveWarehouseTransferBill error:", error);
        return "Something went wrong...";
      });
  }
};

const rejectWarehouseTransferBill = async (billId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(process.env.REACT_APP_API_URL + "/api/warehouse_transfer/reject/" + billId, {
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
      })
      .then((response) => response.data)
      .catch((error) => {
        console.log("rejectWarehouseTransferBill error:", error);
        return "Something went wrong...";
      });
  }
};

const deleteWarehouseTransferBill = async (billId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .delete(process.env.REACT_APP_API_URL + "/api/warehouse_transfer/" + billId, {
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
      })
      .then((response) => true)
      .catch((error) => {
        console.log("deleteWarehouseTransferBill error:", error);
        return false;
      });
  }
};

export {
  getWarehouseTransferBills,
  addWarehouseTransferBill,
  getWarehouseTransferBillById,
  sendWarehouseTransferBillForApproval,
  approveWarehouseTransferBill,
  rejectWarehouseTransferBill,
  executeWarehouseTransfer,
  confirmWarehouseTransferReceived,
  deleteWarehouseTransferBill,
};
